module.exports = __webpack_public_path__ + "static/media/logo-cbc.a6cf6193.svg";